import React, { useRef, useState, useEffect } from "react"
import "./AideModal.css"

export default function AideModal({ onOpen,onClose }) {

  const containerRef = useRef()
  const [page, setPage] = useState(0)

  const handleScroll = () => {
    if (!containerRef.current) return
    const scrollTop = containerRef.current.scrollTop
    const height = containerRef.current.clientHeight
    const index = Math.round(scrollTop / height)
    setPage(index)
  }

  useEffect(() => {
    onOpen?.()
  }, [])

  return (
    <div className="aide-overlay">

      <div className="aide-modal">

        {/* HEADER */}
        <div className="aide-header">
          <span>AIDE</span>
          <button onClick={onClose}>✕</button>
        </div>

        {/* PAGES */}
        <div
          className="aide-container"
          ref={containerRef}
          onScroll={handleScroll}
        >
          <div className="aide-page">
            <img src="/textures/help-1.png" alt="aide-1" />
          </div>

          <div className="aide-page">
            <img src="/textures/help-2.png" alt="aide-2" />
          </div>

          <div className="aide-page">
            <img src="/textures/help-3.png" alt="aide-3" />
          </div>
        </div>

        {/* DOTS */}
        <div className="aide-dots">
          {[0, 1, 2].map(i => (
            <div key={i} className={`dot ${page === i ? "active" : ""}`} />
          ))}
        </div>

      </div>
    </div>
  )
}